export default {
  bulkOptions: [
    {
      key: 'delete_bulk',
      field: 'delete_bulk',
      value: 'true',
      label: 'Delete',
      type: 'danger',
      permissionCode: 'architect.delete_architect',
    },
  ],
  exportImportOptions: {
    export: {
      directly: true,
      url_name: 'api:admin:architect:architect:export',
    },
  },
}